import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import useSocialAuthLocale from "../../hooks/useSocialAuthLocale";

const useHandleCallbackAccessDenied = () => {
  const [getLocale] = useSocialAuthLocale();
  const router = useRouter();
  const lang = getLocale() ?? router.locale;
  const handleCallbackAccessDenied = (
    error: string,
    siteConfig: SiteConfig,
  ) => {
    sessionStorage.setItem("social_auth_error", error);
    const pathname = sessionStorage.getItem("social_auth_path");
    return router.push(pathname ?? "/register", undefined, {
      shallow: false,
      locale: lang === siteConfig.defaultLang ? undefined : lang,
    });
  };
  return {
    handleCallbackAccessDenied,
  };
};
export default useHandleCallbackAccessDenied;
